import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from "react";
import useHttp from "../../../hook/use-http";
import { API_URL_MAIN } from "../../../constants/driveglobalfilterinitalstates_bus";
import "./PdfPage.css";
import NoData from "./NoData";
import ChartLoader from "./ChartLoader";

const ChargeAnalyticsPdf = forwardRef((props, ref) => {
  const { isLoading, error, sendReq: fetchData } = useHttp();
  let { title, template_id, show, soarting, gloablfilter, IND } = props;

  const [refreshDate, setRefreshDate] = useState("");
  const [occurData, setOccurData] = useState(0);
  const [faultData, setFaultData] = useState(0);
  useImperativeHandle(ref, () => ({
    getDataForSlide: () => ({
      refreshDate,
      occurData,
      faultData,
    }),
  }));
  useEffect(() => {
    fetchData(
      {
        url:
          API_URL_MAIN + "energy_analysis_bus/energy_analysis_refreshdate_bus",
        body: {},
      },
      refreshDateData
    );
    fetchData(
      {
        url: API_URL_MAIN + "faultfirstpage_bus/Topvehicleswithfaults_bus_occ",
        body: { filterdata: gloablfilter, IND },
      },
      appyData
    );
    fetchData(
      {
        url:
          API_URL_MAIN +
          "faultfirstpage_bus/Topvehicleswithfaults_imbalance_dur",
        body: { filterdata: gloablfilter, IND },
      },
      appyDataDuration_imbalance
    );
  }, [gloablfilter]);

  const refreshDateData = (data) => {
    setRefreshDate(data.value_as_string);
  };

  const appyData = (data) => {
    setOccurData(data);
  };

  const appyDataDuration_imbalance = (data) => {
    setFaultData(data);
  };

  return (
    <div className="sixthpage">
      <div className="row" style={{ justifyContent: "end" }}>
        <img
          src="../../../assets/img_Bus/Pdf_Page/Tatamotors.png"
          alt=""
          style={{ height: "80px", width: "250px" }}
        />
      </div>
      <div className="row mt-3">
        <div className="col-md-6">
          <span
            className="text-left"
            style={{
              fontSize: "20px",
              fontWeight: "bold",
              color: "#002060",
              paddingLeft: "30px",
            }}
          >
            Fault Analytics:{" "}
          </span>
          <span
            className="text-right"
            style={{ color: "#002060", fontSize: "12px" }}
          >
            {props.startdate} - {props.enddate}
          </span>
        </div>
      </div>
      <div className="row mt-4">
        <div
          className="col-md-6"
          style={{ paddingLeft: "90px", paddingRight: "30px" }}
        >
          {/* <span>Top 10 Vehicle</span> */}
          {isLoading ? (
            <ChartLoader />
          ) : faultData.length > 0 > 0 ? (
            <>
              <div id="slide_4_table_fault">
                <div
                  className="text-center"
                  style={{
                    borderRadius: "5px",
                    border: "1px solid black",
                    backgroundColor: "#44546a",
                    color: "#fff",
                    fontWeight: "bold",
                    height: "35px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  Top 10 Vehicle with Current Imbalance
                </div>
                <table className="table pdftable">
                  <thead>
                    <tr style={{ backgroundColor: "#44546a", color: "#fff" }}>
                      <th>Vin</th>
                      <th>Minutes</th>
                    </tr>
                  </thead>
                  <tbody>
                    {faultData.length > 0 &&
                      faultData.map((item, index) => (
                        <tr key={index}>
                          <td>{item.key.vehicleId}</td>
                          <td>{item.duration.value.toFixed(0)}</td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </>
          ) : (
            <div className="no_data_slide_fault_slide_4">
              <NoData />
            </div>
          )}
        </div>

        <div
          className="col-md-6"
          style={{ paddingLeft: "40px", paddingRight: "90px" }}
        >
          {isLoading ? (
            <ChartLoader />
          ) : occurData.length > 0 > 0 ? (
            <>
              <div id="slide_4_table_occurance">
                <div
                  className="text-center"
                  style={{
                    borderRadius: "5px",
                    border: "1px solid black",
                    backgroundColor: "#44546a",
                    color: "#fff",
                    fontWeight: "bold",
                    height: "35px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  Top 10 Vehicle with Faults
                </div>
                <table className="table pdftable">
                  <thead>
                    <tr style={{ backgroundColor: "#44546a", color: "#fff" }}>
                      <th>Vin</th>
                      <th>Occurrence</th>
                    </tr>
                  </thead>
                  <tbody style={{ color: "black" }}>
                    {occurData.length > 0 &&
                      occurData.map((item, index) => (
                        <tr key={index}>
                          <td>{item.key.vehicleId}</td>
                          <td>{item.occurance.value}</td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </>
          ) : (
            <div className="no_data_slide_occurance_4">
              <NoData />
            </div>
          )}
        </div>
      </div>

      <div
        className="row mt-4"
        style={{ color: "black", paddingLeft: "90px", fontSize: "16px" }}
      >
        The vehicles with maximum occurrences of current imbalance mentioned
        above can be investigated.
      </div>

      <div
        className="row sixthbottomcontent pl-4"
        style={{ paddingTop: "245px" }}
      >
        <div className="col-md-3">
          <img
            src="../../../assets/img_Bus/Pdf_Page/footer.png"
            alt=""
            style={{ height: "70px", width: "200px" }}
          />
        </div>
        <div className="col-md-1"></div>
        <div className="col-md-4">
          <p
            style={{
              fontSize: "11px",
              paddingTop: "60px",
              paddingLeft: "10px",
            }}
          >
            Copyright, Confidential, Tata Motors Limited
          </p>
        </div>
      </div>
    </div>
  );
});
export default ChargeAnalyticsPdf;
